import { render, staticRenderFns } from "./SfDropdown.vue?vue&type=template&id=28076ea0&"
import script from "./SfDropdown.vue?vue&type=script&lang=js&"
export * from "./SfDropdown.vue?vue&type=script&lang=js&"
import style0 from "./SfDropdown.vue?vue&type=style&index=0&id=28076ea0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports